var mockTranslation = require('../utils/mock-translation')
var getCookieValue = require('../utils/get-cookie-value')
var isObject = require('../utils/is-object')

module.exports = {
  store: {},
  /**
   * Checks specific cookie to see if we should mock translations
   * before returning
   */
  shouldMock: function() {
    var value = +getCookieValue('I18N_MOCK')
    if (typeof value === 'number' && value >= 1) return value
    return 0
  },
  /**
   * Returns a namespaced key, if namesapce is provided
   * @param {string} key The key name
   * @param {string} [namespace] The namespace to append
   * @returns {string} The namespaced key, or input key if no namespace provided
   */
  getNamespacedKey: function(key, opts) {
    if (typeof opts !== 'object') opts = {}
    var prefix = ''
    if (opts.application_name) prefix += '@' + opts.application_name + '/'
    if (opts.namespace) prefix += '@' + opts.namespace + '/'
    return prefix + key
  },
  /**
   * Gets the value for a specific key
   * @param {key} string The key name whose value is desired
   * @returns {string} The value for the key, or the key itself if no match
   */
  getKey: function(key, options) {
    var targetKey = this.getNamespacedKey(key, options)
    var data = this.store[targetKey] || key
    // check if we should be mocking (ie we have a multiplier >= 1)
    var mockMultiplier = this.shouldMock()
    return mockMultiplier ? mockTranslation(data, mockMultiplier) : data
  },
  /**
   * Adds a hash of key: value pairs to the local store
   * @param {obj} object Key value pairs to make globally available
   */
  add: function(obj, opts) {
    // bail and warn if we don't have usable data
    if (!isObject(obj)) {
      console.error(
        'translationStore.add requires an object as its first argmument, but received ' +
          obj.toString()
      )
      return
    }
    // add to either the root object or the namespace key
    for (var key in obj) {
      var targetKey = this.getNamespacedKey(
        key,
        typeof opts === 'string' ? { namespace: opts } : opts
      )
      this.store[targetKey] = obj[key]
    }
  },
  /**
   * Removes a key or namespace from the store
   * @param {string} key The key to remove
   * @param {string} [namespace] An optional namespace if the key was namespaced
   */
  removeKey: function(key, opts) {
    var targetKey = this.getNamespacedKey(
      key,
      typeof opts === 'string' ? { namespace: opts } : opts
    )
    if (this.store[targetKey]) {
      delete this.store[targetKey]
    }
  },
  /**
   * Removes all keys in a namespace
   * @param {string} namespace The namespace to remove
   */
  removeNamespace: function(namespace) {
    var self = this
    var ns = '@' + namespace + '/'
    // filter and reduce in one pass to update store
    var nextStore = Object.keys(this.store).reduce(function(obj, key) {
      if (key.indexOf(ns) === 0) return obj
      obj[key] = self.store[key]
      return obj
    }, {})
    this.store = nextStore
  },
  clear: function() {
    this.store = {}
  },
  /**
   * Syncs translations from a global variable.
   * Expects to find an array of objects as the value of the specified global variable:
   * window.__TRANSLATIONS__ = [
   *   { translations: { [key]: value, ... }},
   *   { translations: { [key]: value, ... }, application_name: 'common', namespace: 'forms' }
   * ]
   * @param {string} [varName=__TRANSLATIONS__] Name of global variable where translations array is stored.
   */
  syncTranslations: function(varName) {
    var data = window[varName || '__TRANSLATIONS__']
    if (!Array.isArray(data)) return
    // keep a reference to our current instance for use in forEach
    var self = this
    data.forEach(function(obj) {
      // extract options
      var options = Object.keys(obj).reduce(function(collection, key) {
        // gather everything except 'translations'
        if (key !== 'translations') {
          collection[key] = obj[key]
        }
        return collection
      }, {})
      self.add(obj.translations || {}, options)
    })
  },
}
